import { render, staticRenderFns } from "./ComponentsTable.vue?vue&type=template&id=86b65e44&scoped=true&"
import script from "./ComponentsTable.vue?vue&type=script&lang=js&"
export * from "./ComponentsTable.vue?vue&type=script&lang=js&"
import style0 from "./ComponentsTable.vue?vue&type=style&index=0&id=86b65e44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b65e44",
  null
  
)

export default component.exports